<template>
  <div class="column content-box">
    <div class="row">      
      <div class="small-12 columns integrations-wrap">
        <woot-loading-state
          v-if="isLoading"          
        />
        <div class="row integrations" v-if="!isLoading">
          <div
            v-for="item in integrationsList"
            :key="item.id"
            class="small-12 columns integration"
          >
            <integration
              :integration-id="item.id"
              :integration-logo="item.logo"
              :integration-name="item.name"
              :integration-description="item.description"
              :integration-enabled="item.enabled"
              :integration-action="item.action"
            />
          </div>
          <p
            v-if="!integrationsList.length"
            class="small-12 no-items-error-message with-right-space"
            >
            {{ $t('INTEGRATION_SETTINGS.LIST.404') }}
          </p>
        </div>        
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Integration from './Integration';

export default {
  components: {
    Integration,
  },
  computed: {
    ...mapGetters({
      integrations: 'integrations/getIntegrations',
      currentUser: 'getCurrentUser',
      typeAccount: 'getCurrentTypeAccount',      
      integrationsUiFlags: 'integrations/getUIFlags',
      assistentUiFlags: 'assistent/getUIFlags',
      assistents: 'assistent/getAssistents',
    }),
    integrationsList(){      
      let integrationDashboardApps = {
        id: 'dashboard-apps',
        logo: 'dashboard-apps.svg',
        name: this.$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.TITLE'),
        description: this.$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DESCRIPTION'),
        enabled: true,
        action: '/dashboard-apps',
      }

      if(this.typeAccount == 'parent_account'){
        if(['SuperAdmin', 'UserSupport'].includes(this.currentUser.type)){
          return [integrationDashboardApps];
        }
        return [];
      }
      const integrationAssistent = {
        id: 'assistent',
        logo: 'assistent.png',
        name: `${this.$t('INTEGRATION_SETTINGS.ASSISTENT.TITLE')} (LEGADO)`,
        description: this.$t('INTEGRATION_SETTINGS.ASSISTENT.DESCRIPTION'),
        enabled: true,
        action: '/assistent',
      }
      let integrationsList = [...this.integrations, integrationDashboardApps, {
          id: 'webhooks-send-messages/autoavaliar',
          logo: 'auto-avaliar.png',
          name: this.$t('INTEGRATION_SETTINGS.AUTOAVALIAR.TITLE'),
          description: this.$t('INTEGRATION_SETTINGS.AUTOAVALIAR.DESCRIPTION'),
          enabled: true,
          action: '/webhooks-send-messages/autoavaliar',
        },
        {
          id: 'syonet',
          logo: 'syonet.svg',
          name: this.$t('INTEGRATION_SETTINGS.SYONET.TITLE'),
          description: this.$t('INTEGRATION_SETTINGS.SYONET.DESCRIPTION'),
          enabled: true,
          action: '/syonet',
        },
      ];
      if(!this.assistentUiFlags.isFetching && this.assistents.length) {
        return [...integrationsList, integrationAssistent];
      }
      return integrationsList;
    },
    isLoading() {
      return this.integrationsUiFlags.isFetching || this.assistentUiFlags.fetchingList;
    },
  },
  mounted() {
    this.$store.dispatch('integrations/get');
    this.$store.dispatch('assistent/get', { version: 'v1' });
  },
};
</script>
